import { render, staticRenderFns } from "./QuestionnaireTemplate.vue?vue&type=template&id=21175bc2&scoped=true"
import script from "./QuestionnaireTemplate.vue?vue&type=script&lang=js"
export * from "./QuestionnaireTemplate.vue?vue&type=script&lang=js"
import style0 from "./QuestionnaireTemplate.vue?vue&type=style&index=0&id=21175bc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21175bc2",
  null
  
)

export default component.exports